export default __webpack_public_path__ + "static/media/markofthedevourer.68fa1402.png";